import React, { useRef } from 'react';
import { FormikValues } from 'formik';
import { Card } from '@material-ui/core';
import AssessmentIcon from '@material-ui/icons/Assessment';
import InlineForm from '../../../common/inline/InlineForm';
import InlineFormik from '../../../common/inline/InlineFormik';
import InlineTextField from '../../../common/inline/InlineTextField';
import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';

export interface JiraDetailCardProps {
  issue: any;
}

const JiraDetailCard: React.FC<JiraDetailCardProps> = ({ issue }) => {
  const formikRef = useRef<FormikValues>();
  const functionalArea = issue.fields.customfield_10034 || '';
  const components = issue.fields.components || [];
  const serviceLine = issue.fields.customfield_10033 || '';
  return (
    <Card>
      <CardTitle>
        <AssessmentIcon />
        Details
      </CardTitle>
      <CardContent padding='medium'>
        <InlineFormik
          innerRef={(formik: any) => (formikRef.current = formik)}
          initialValues={{}}
          onSubmit={() => {}}
        >
          <InlineForm>
            <InlineTextField
              name='functionalArea'
              label='Functional Area'
              value={functionalArea}
            />
            <InlineTextField
              name='components'
              label='Components'
              value={components.map((component: any, index: number) =>
                components.length === index + 1
                  ? component.name
                  : component.name + ', '
              )}
            />
            <InlineTextField
              name='serviceLine'
              label='Service Line'
              value={serviceLine}
            />
          </InlineForm>
        </InlineFormik>
      </CardContent>
    </Card>
  );
};

export default JiraDetailCard;
